<div class="content">

  <div class="wrapper">

    <mat-expansion-panel [expanded]="expand" id="intro">
      <img [src]="this.url + '/tenant/' + tenant.getId() +  '/splash-image'" alt="Splash" style="width:100%;">
    </mat-expansion-panel>

    <div *ngIf='landingh !== undefined || landingt !== undefined' fxLayout="row" fxLayout.sm="column"
         fxLayout.xs="column"
         fxLayoutGap="1%">
      <mat-card *ngIf="!expand" class="content-header">
        <mat-card-header>
          <div class="material-icons" mat-card-avatar>public</div>
          <mat-card-title>{{landingh !== undefined ? landingh : '1'}}</mat-card-title>
        </mat-card-header>
        <mat-card-content style="white-space: pre-line;">
          {{landingt !== undefined ? landingt : ''}}
        </mat-card-content>
      </mat-card>
    </div>

    <div fxLayout="row" fxLayout.sm="column" fxLayout.xs="column" fxLayoutGap="1%">

      <mat-card fxFlex="1 1" fxFlex.sm="1 1" fxFlex.xs="1 1" fxLayout="row" style="height:600px">
        <rsp-map
          [mappoints]="mappoints"
          [markers]="markers"
          [regions]="regions"
          [mapRadiusKm]="tenant.getInfo().mapRadiusKm"
          fxFlex="1 1 100%">
        </rsp-map>
      </mat-card>
    </div>

  </div>

</div>
